import { t } from 'i18next';

export const idConditions = {
  savedPages: 50,
};

export const tagConditions = {
  1: t('equals'),
  2: t('not equals'),
  3: t('all values'),
  10: t('contains'),
  11: t('regular expression'),
  13: t('not contains'),
  20: t('greater than'),
  21: t('less than'),
  22: t('greater than or equals'),
  23: t('lower than or equals'),
  24: t('is between'),
  30: t('clear'),
  31: t('clouds'),
  32: t('drizzle'),
  33: t('dust'),
  34: t('fog'),
  35: t('mist'),
  36: t('rain'),
  37: t('smoke'),
  38: t('snow'),
  39: t('thunderstorm'),
  40: t('ignore parameters'),
  41: t('is declared'),
  42: t('is not declared'),
  43: t('ID selector'),
  44: t('class selector'),
  45: t('element selector'),
  50: t('Saved page(s)'),
};

export const triggerTranslate = {
  DEVICE: {
    1: t('mobile phone'),
    2: t('tablet'),
    3: t('desktop'),
  },
  BROWSER: {
    1: 'Chrome',
    2: 'Firefox',
    3: 'Internet Explorer',
    4: 'Safari',
    5: 'Edge',
    6: 'Custom',
    7: 'UC Browser',
  },
  SOURCE_TYPE: {
    1: t('Organic'),
    2: t('Referral'),
    3: t('Direct'),
  },
  WEATHER: {
    3: t('all'),
    30: t('clear'),
    31: t('clouds'),
    32: t('drizzle'),
    33: t('dust'),
    34: t('fog'),
    35: t('mist'),
    36: t('rain'),
    37: t('smoke'),
    38: t('snow'),
    39: t('thunderstorm'),
  },
};
